export const SCHEDULE_STARTED_MODAL = 'SCHEDULE_STARTED_MODAL'
export const PRE_PROCESS_EDIT_MODAL = 'PRE_PROCESS_EDIT_MODAL'
export const MIN_CUTOFF_OFFSET = 2
export const MAX_CUTOFF_OFFSET = 72
export const TIME_FORMAT = 'HH:mm'
export const MIN_MANUAL_SEND_FUTURE_MINUTES = 5
export const MIN_MANUAL_SEND_BUFFER_MINUTES = 4 // buffer to allow user to review page before clicking Generate button
export const MANUAL_SEND_DATE_PAST_ERROR = 'Manual sends cannot be scheduled in the past'
export const MANUAL_SEND_DATE_TOO_FAR_ERROR = 'Manual sends cannot be scheduled more than 3 days out'
export const MANUAL_SEND_TIME_BUFFER_ERROR = `Selected time must be at least ${MIN_MANUAL_SEND_FUTURE_MINUTES} minutes in the future`
export const UNSUCCESSFUL_MANUAL_SEND = 'Oops something went wrong. your newsletter was not scheduled. Try again or contact Customer Success'
export const SUCCESSFUL_MANUAL_SEND = 'Your manual send is set. You can schedule your next newsletter after this time.'
export const ISSUE_LOOKBACK_DAYS_FOR_SEND = 6
export const SEND_SCHEDULE_MESSAGE = "You can now proceed with sending the schedule."
export const CANCEL_ISSUE_THRESHOLD_IN_HOUR = 1
export const MANUAL_SCHEDULE_GENERATE_DELAY_MILLISECONDS = 2000
export const MAX_MANUAL_SCHEDULE_GENERATE_TIMEOUT_MILLISECONDS = 20000
